import Swal from "sweetalert2";

// ---------------------------common erro message------------------------------------

export const statusInfo: Record<
  number | "default",
  { title: string; message: string; type: "error" | "success" }
> = {
  200: {
    title: "Success",
    message: "Your request completed successfully.",
    type: "success",
  },
  202: {
    title: "Accepted",
    message: "Your request is being processed.",
    type: "success",
  },
  400: {
    title: "Bad Request",
    message: "The request could not be understood.",
    type: "error",
  },
  401: {
    title: "Unauthorized",
    message: "Please login again.",
    type: "error",
  },
  403: {
    title: "Access Denied",
    message: "You don't have permission.",
    type: "error",
  },
  404: {
    title: "Page Not Found",
    message: "The page you are looking for does not exist.",
    type: "error",
  },
  500: {
    title: "Server Error",
    message: "Something went wrong on our side.",
    type: "error",
  },
  default: {
    title: "Oops!",
    message: "Something went wrong.",
    type: "error",
  },
};

// Base toast config
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  showCloseButton: true,
  background: "#fff",
  iconColor: "#000",
  customClass: {
    title: "toast-title",
  },
  didOpen: () => {
    const container = document.querySelector(".swal2-container") as HTMLElement;
    if (container) {
      container.style.zIndex = "9999999";
    }
  },
});

// Show success toast
export const showSuccess = (message?: string) => {
  // Toast.fire({
  //   icon: "success",
  //   title: message || "Operation completed successfully.",
  //   background: "#f6ffed",
  //   iconColor: "#52c41a",
  // });
};

// Show error toast
export const showError = (code?: number, message?: string) => {
  const info = code
    ? (statusInfo[code] ?? statusInfo.default)
    : statusInfo.default;
    
  // Toast.fire({
  //   icon: "error",
  //   title: message || info.message,
  //   background: "#fff5f5",
  //   iconColor: "#d33",
  // });
};

// Extract error message from API response
export const extractErrorMessage = (
  err: any,
): { code?: number; message: string } => {
  if (err?.code && err?.message) {
    return { code: err.code, message: err.message };
  }

  const code = err?.response?.status;
  const message =
    err?.response?.data?.errorMessage ||
    err?.response?.data?.error?.errorMessage ||
    err?.response?.data?.data?.errorMessage ||
    err?.message ||
    statusInfo.default.message;

  return { code, message };
};
